import { z } from 'zod';
import { passwordSchema } from '../auth/password.js';

export const resetInstitutionUserPasswordParamsSchema = z.object({
  user_id: z.uuid('Valid user ID is required'),
});

export const resetInstitutionUserPasswordSchema = z.object({
  new_password: passwordSchema,
});

export type ResetInstitutionUserPasswordParams = z.infer<typeof resetInstitutionUserPasswordParamsSchema>;
export type ResetInstitutionUserPasswordPayload = z.infer<typeof resetInstitutionUserPasswordSchema>;
